/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PredictiveCampaignAnswerDto } from './PredictiveCampaignAnswerDto';
export type PredictiveCampaignDto = {
    id: string;
    description: string | null;
    icon: string | null;
    name: string;
    status: PredictiveCampaignDto.status;
    target_price_id: string;
    canceled: boolean;
    next_list_release: string;
    answers: Array<PredictiveCampaignAnswerDto>;
    period_end: string;
    setup_step: PredictiveCampaignDto.setup_step;
    list_count: number;
};
export namespace PredictiveCampaignDto {
    export enum status {
        DRAFT = 'DRAFT',
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
    export enum setup_step {
        DETAILS = 'DETAILS',
        AUDIENCE = 'AUDIENCE',
        INSIGHTS = 'INSIGHTS',
        REVIEW = 'REVIEW',
        FINISHED = 'FINISHED',
    }
}

